import React from 'react';
import { useThemeSettings } from '../../hooks/useThemeSettings';
import { useSubscription } from '../../hooks/useSubscription';

export function PoweredBy() {
  const { theme } = useThemeSettings();
  const { subscription } = useSubscription();
  const isDark = theme.mode === 'dark';
  
  // Si showPoweredBy est false et que l'utilisateur a un plan pro ou enterprise, on cache la mention
  if (
    theme.showPoweredBy === false && 
    subscription?.tier && 
    ['professional', 'enterprise'].includes(subscription.tier)
  ) {
    return null;
  }
  
  return (
    <div className={`text-center py-1 text-[9px] mb-2 ${
      isDark ? 'text-gray-400' : 'text-gray-600'
    }`}>
      <a 
        href="https://botmaker-agency.ai"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:text-indigo-400 transition-colors"
      >
        Propulsed by Botmaker Agency
      </a>
    </div>
  );
}